import mermaid from "mermaid"

mermaid.initialize({
  startOnLoad: false,
  theme: "neutral",
  securityLevel: "loose",
  flowchart: { useMaxWidth: true, htmlLabels: true }
})

export function renderGraph(containerId) {
  const container = document.getElementById(containerId)
  if (!container) return
  const definition = container.dataset.mermaidDefinition
  if (!definition) return

  const id = `m-${Date.now()}`
  mermaid.render(id, definition).then(({ svg }) => {
    container.innerHTML = svg
  })
}

document.addEventListener("turbo:load", () => {
  renderGraph("project-index-graph")
  renderGraph("project-show-graph")
})

document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(() => renderGraph("project-show-graph"), 50)
})

document.addEventListener("alpine:init", () => {
  Alpine.data("project_graph_lightbox", () => ({
    open: false,
    init() {
      this.$watch("open", (val) => {
        if (val) {
          this.$nextTick(() => {
            const body = this.$el.querySelector(".graph-lightbox-body")
            if (body) renderGraph(body.id)
          })
        }
      })
    }
  }))
})